"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CREATE_APPROVER_REPLACEMENT = void 0;
exports.CREATE_APPROVER_REPLACEMENT = {
    USER_NOT_FOUND: {
        usecase: 'CREATE_APPROVER_REPLACEMENT',
        type: 'USER_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'Usuário não encontrado.',
            'EN-US': 'User not found.',
        },
    },
    APPROVER_NOT_FOUND: {
        usecase: 'CREATE_APPROVER_REPLACEMENT',
        type: 'APPROVER_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'Aprovador não encontrado.',
            'EN-US': 'Approver not found.',
        },
    },
    REPLACER_NOT_FOUND: {
        usecase: 'CREATE_APPROVER_REPLACEMENT',
        type: 'REPLACER_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'Substituto não encontrado.',
            'EN-US': 'Replacer not found.',
        },
    },
    UNAUTHORIZED_ACTOR: {
        usecase: 'CREATE_APPROVER_REPLACEMENT',
        type: 'UNAUTHORIZED_ACTOR',
        messageLangMap: {
            'PT-BR': 'Usuário ator não tem permissão para criar substituição de aprovação.',
            'EN-US': 'Actor user is not allowed to create approval replacement.',
        },
    },
    APPROVER_HAS_NO_APPROVAL_FLOWS: {
        usecase: 'CREATE_APPROVER_REPLACEMENT',
        type: 'APPROVER_HAS_NO_APPROVAL_FLOWS',
        messageLangMap: {
            'PT-BR': 'Aprovador não possui fluxos de aprovação.',
            'EN-US': 'Approver has no approval flows.',
        },
    },
    APPROVER_REPLACEMENT_DATA_INVALID: {
        usecase: 'CREATE_APPROVER_REPLACEMENT',
        type: 'APPROVER_REPLACEMENT_DATA_INVALID',
        messageLangMap: {
            'PT-BR': 'Dados da substituição do aprovador são inválidos.',
            'EN-US': 'Approver replacement data is invalid.',
        },
    },
};
